import ApiServer from "../ApiServer.js";
import {SyncCache} from "../lib/SyncCache.ts";

export const ContactCache = new SyncCache(
  ApiServer.ctcsync,
  function(a,b){return a.displayName.localeCompare(b.displayName)
})

Object.assign(ApiServer.types.IContact.prototype,{
  onDecode(json){
    if(this.birthDate){
      this.localBirthDate = new Date(json.birthDate.substring(0,19))
    }
    this.displayName = ((this.firstName||"")+" "+(this.lastName||"")).trim();
    this.hasDetail = this.devices.length||this.addresses.length ||this.birthDate!==undefined
  }
 });
 
 Object.assign(ApiServer.types.IDevice.prototype,{
  onDecode(){
    this.label = {
      MOBILE:'labels.mobile',
      EMAIL:'labels.email'
      }[this.deviceType]||'labels.phone'
    this.placeholder = {
      EMAIL:'johndoe@email.com'
      }[this.deviceType]||'(902) 930-3589'
    
    this.icon = {
      MOBILE:'contact.ic_contact_mobile_phone',
      EMAIL:'ic_email'
      }[this.deviceType]||'contact.ic_contact_phone'
    
  }
 });
 
 Object.assign(ApiServer.types.IAddress.prototype,{
  onDecode(){
    this.label = {
      WORK:'addressType.WORK'
      }[this.placeType]||'addressType.HOME'
    this.icon = {
      WORK:'contact.ic_contact_work_address'
      }[this.placeType]||'ic_location'
    
    this.placeholder = 'modalplace.placeholder_address'
   
  }
 });